import {
  Typography,
  CardContent,
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Divider
} from "@mui/material";

export default function SkeletonCardProdutos() {
  const skeletonRows = Array.from({ length: 3 }, (_, index) => index);

  return (
    <CardContent>
      <Grid container>
        <Grid size={{xs: 12, md: 5.5}}>
          <Typography variant="h6" component="h2" gutterBottom>
            Produtos da NF
          </Typography>

          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><b>Produto / Quantidade</b></TableCell>
                  <TableCell align="center"><b>Quantidade recebida</b></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {skeletonRows.map((index) => (
                  <TableRow key={index} sx={{ '& td': { minHeight: '60px', height: '60px' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell>
                      <Skeleton variant="text" width="80%" height={20} />
                    </TableCell>
                    <TableCell align="center">
                      <Skeleton variant="rectangular" width={100} height={40} sx={{ borderRadius: 1 }} />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
                        <Skeleton variant="rectangular" width={38} height={22} sx={{ borderRadius: 3 }} />
                        <Skeleton variant="text" width={60} height={16} />
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        
        <Grid>
          <Divider orientation="vertical" />
        </Grid>
        
        <Grid size={{xs: 12, md: 6.4}}>
          <Typography ml={2} variant="h6" component="h2" gutterBottom>
            Produtos da OC
          </Typography>

          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><b>Código da OC</b></TableCell>
                  <TableCell><b>Produto comprado</b></TableCell>
                  <TableCell align="right"><b>Quantidade</b></TableCell>
                  <TableCell align="right"><b>Valor</b></TableCell>
                  <TableCell><b>Status</b></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {skeletonRows.map((index) => (
                  <TableRow key={index} sx={{ '& td': { minHeight: '60px', height: '60px' }, '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell>
                      <Skeleton variant="text" width="60%" height={20} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width="90%" height={20} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width="70%" height={20} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width="80%" height={20} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="rectangular" width={80} height={24} sx={{ borderRadius: 3 }} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="circular" width={32} height={32} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </CardContent>
  );
}